<template>
    <div>
        <Header></Header>
        <div class="page-container">

            <div class="container">
                <div class="form-container">
                    <b-card id="card">
                        <div style="height: 90px; margin-bottom: 10px">
                            <p style="font-family: 'Mansalva', cursive; font-weight: bold; font-size: 60px;">Add Member</p>
                        </div>
                        <ul style="padding: 0; text-align: left">
                            <li style="color: red; list-style: none; display: block; width: 100%;" v-bind:key="error"
                                v-for="error in errors">{{ error }}</li>
                        </ul>
                        <div class="row" style="width: 100%; margin: 0;">
                        <div class="outer-container">
                            <div class="inner-container-left">
                                <b-form-input id="admin" v-model="administratorName.value"
                                              type="text" v-bind:placeholder="administratorNamePlaceholder"></b-form-input>
                            </div>
                            <div class="spacer"></div>
                            <div class="inner-container-right">
                                <b-form-input id="displayName" v-model="displayName"
                                              type="text" v-bind:placeholder="displayNamePlaceholder"></b-form-input>
                            </div>
                        </div>
                        </div>
                        <div style="height: 25px;"></div>
                        <div class="row" style="width: 100%; margin: 0;">
                            <div class="outer-container">
                                <div class="inner-container-left">
                                    <b-form-input id="password" v-model="administratorPassword.value"
                                                  type="password" v-bind:placeholder="administratorPasswordPlaceholder"></b-form-input>
                                </div>
                                <div class="spacer"></div>
                                <div class="inner-container-right">
                                    <b-form-input id="confirmPassword" v-model="confirmPassword.value"
                                                  type="password" v-bind:placeholder="confirmPasswordPlaceholder"></b-form-input>
                                </div>
                            </div>
                        </div>
                        <div style="height: 25px;"></div>
                        <div style="padding-left: 10px; padding-right: 10px">
                        <b-form-textarea
                                id="textarea"
                                type="text"
                                v-model="authorDescription"
                                :placeholder="descriptionPlaceholder"
                                rows="3"
                                max-rows="6"
                        ></b-form-textarea>
                        </div>
                        <div style="height: 25px;"></div>
                        <div class="row" style="width: 100%; margin: 0;">
                            <div class="image-spacer"></div>
                            <div class="input-group-image"
                                 @click="chooseImage"
                                 :style="{ 'background-image': `url(${fileImageString})` }"
                            >
                                <div class="input-group-prepend h-100" style="width: 100%">
                                    <div style="text-align: right; width: 100%">
                                        <span
                                                v-if="!fileImageString"
                                                class="placeholder"
                                        >
                                        Choose an Image
                                        </span>
                                        <input
                                        class="file-input"
                                        ref="file"
                                        type="file"
                                        id="imgSrc"
                                        @input="getFile"
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="image-spacer"></div>
                        </div>
                        <div style="height: 25px;"></div>
                        <b-form-checkbox style="float: left; margin-left: 20px; margin-bottom: 20px;" size="lg"
                                         id="checkbox" v-model="isPermanentAdmin" >
                            no restrictions</b-form-checkbox>
                    </b-card>
                </div>
                <div v-if="!loading" class="container-button" v-on:keyup.enter="register">
                    <b-button @click="register" type="submit" style="max-width: 300px;
            display: block; margin: 20px auto;" pill variant="primary" class="btn btn-lg btn-block">Send</b-button>
                </div>
                <div v-else class="container-button">
                    <div style="height: 100%; width: 100%; display: flex; justify-content: center; align-items: center">
                        <b-spinner style="max-width: 300px; display: block; margin: 20px auto;" variant= "light" label="Uploading ..."></b-spinner>
                    </div>
                </div>
            </div>

        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Footer from "@/components/Footer";
    import Header from "@/components/Header";
    import {mapActions, mapGetters} from "vuex";
    import {isEqual} from "lodash";
    import UploadService from "@/service/UploadService";

    export default {
        name: "AdminDashboard",
        components: {Header, Footer},
        data() {
            return {
                administratorName: {
                    value: '',
                    valid: true
                },
                displayName: '',
                administratorPassword: {
                    value: '',
                    valid: true
                },
                confirmPassword: {
                    value: '',
                    valid: true
                },
                authorDescription: '',
                isPermanentAdmin: false,
                error: false,
                administratorNamePlaceholder: 'name',
                displayNamePlaceholder: 'displayed name',
                administratorPasswordPlaceholder: 'password',
                confirmPasswordPlaceholder: 'confirm password',
                descriptionPlaceholder: 'description of yourself',
                file: null,
                fileName: null,
                fileImageString: null,
                errors: [],
                loading: false
            };
        },
        computed: {
            ...mapGetters(['isSuperAdmin', 'isAuthenticated']),
        },
        methods: {
            ...mapActions(['registerAdmin']),
            async register() {
                this.loading = true;
                if(!this.checkForm) {
                    console.log(this.administratorName.value);
                    console.log(this.administratorPassword.value);
                    console.log(this.isPermanentAdmin);
                    return null;
                }
                    if (!this.isSuperAdmin) {
                        return null;
                    }

                await  UploadService.uploadFile(this.file, this.fileName);
                console.log(this.isSuperAdmin);
                    let name = this.administratorName.value;
                    console.log('displayName: ' + this.displayName);
                    let password = this.administratorPassword.value;
                    console.log('isPermaAdmin: ' + this.isPermaAdmin);
                    console.log('authorDesc: ' + this.authorDescription);
                    console.log('authorImage: ' + this.authorImage);
                    const response = this.registerAdmin({
                        name: name,
                        displayName: this.displayName,
                        password: password,
                        isPermaAdmin: this.isPermanentAdmin,
                        authorDescription: this.authorDescription,
                        authorImage: this.fileName

                    });
                this.$router.push('/login');
                this.loading = false;
                    console.log(response);
            },

            checkForm: function () {
                this.error = false;
                this.errors = null;
                if (this.administratorName.value && this.administratorPassword.value && this.confirmPassword.value
                    && isEqual(this.administratorPassword.value, this.confirmPassword.value)
                    && this.administratorPassword.value.length >= 8) {
                    let elem = document.getElementById('admin');
                    elem.style.border = "1px solid green";
                    let elem2 = document.getElementById('password');
                    elem2.style.border = "1px solid green";
                    let elem3 = document.getElementById('confirmPassword');
                    elem3.style.border = "1px solid green";

                    return true;
                }

                if (!this.administratorName.value) {
                    this.administratorNamePlaceholder ='Name required.';
                    let elem = document.getElementById('admin');
                    elem.style.border = "1px solid red";
                    this.error = true;
                } else {
                    let elem = document.getElementById('admin');
                    elem.style.border = "1px solid green";
                }
                if (!this.administratorPassword.value || this.administratorPassword.value.length < 8) {
                    if (!this.administratorPassword.value) {
                        this.administratorPasswordPlaceholder = 'Password required.';
                    } else {
                        this.administratorPassword.value = '';
                        this.administratorPasswordPlaceholder = 'Password must be at least 8 characters long.';
                    }
                    let elem = document.getElementById('password');
                    elem.style.border = "1px solid red";
                    this.error = true;
                } else {
                    let elem = document.getElementById('password');
                    elem.style.border = "1px solid black";
                }

                if (!this.administratorName.value) {
                    this.administratorNamePlaceholder ='Name required.';
                    let elem = document.getElementById('admin');
                    elem.style.border = "1px solid red";
                    this.error = true;
                } else {
                    let elem = document.getElementById('admin');
                    elem.style.border = "1px solid green";
                }
                if (!this.confirmPassword.value || this.confirmPassword.value.length < 8) {
                    if (!this.confirmPassword.value) {
                        this.confirmPasswordPlaceholder = 'Password required.';
                    } else {
                        this.confirmPassword.value = '';
                        this.confirmPasswordPlaceholder = 'Password must be at least 8 characters long.';
                    }
                    let elem = document.getElementById('confirmPassword');
                    elem.style.border = "1px solid red";
                    this.error = true;
                } else {
                    let elem = document.getElementById('confirmPassword');
                    elem.style.border = "1px solid black";
                }

                if (!isEqual(this.administratorPassword.value, this.confirmPassword.value)) {
                    let elem = document.getElementById('password');
                    elem.style.border = "1px solid black";
                    this.administratorPassword.value = '';
                    this.administratorPasswordPlaceholder = 'Passwords must match.';
                    let elem2 = document.getElementById('confirmPassword');
                    elem2.style.border = "1px solid black";
                    this.confirmPassword.value = '';
                    this.confirmPasswordPlaceholder = 'Passwords must match.';
                }
                return false;
            },
            chooseImage () {
                this.$refs.file.click()
            },
            getFile() {
                this.file = this.$refs.file.files[0];
                if (this.file !== null) {
                    this.fileName = this.file.name;
                    this.correctFileType = UploadService.checkFileType(this.file);
                    this.timestamp = UploadService.getTimeStamp();
                    const reader = new FileReader;
                    reader.onload = (e) => {
                        this.fileImageString = e.target.result;
                    };

                    reader.readAsDataURL(this.file);
                    this.$emit('input', this.file)
                }
                console.log(this.fileImageString);
                console.log('file: ' + this.file);
                console.log('fileName: ' + this.fileName);
            },
        }
    }
</script>

<style scoped>

    .page-container {
        background: linear-gradient(to left, black, #202020);
        min-height: 100vh;
        margin-top: 50px;
    }

    .container {
        max-width: 800px;
    }

    .input-group-image {
        width: 50%;
        min-height: 400px;
        background-size: cover; background-position: center center;
        margin: 0; padding: 0;
    }

    .file-input {
        height: auto;
    }

    .placeholder {
        border: 1px solid gray;
        box-shadow: 0 0 15px;
        opacity: 0.5;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #333;
        font-size: 18px;
        font-family: Helvetica;
        margin: 0;
    }
    .placeholder:hover {
        box-shadow: 0 0 20px;
    }
    .file-input {
        display: none;
    }

    .image-spacer {
        width: 25%;
    }

    .outer-container {
        width: 100%;
    }

    .inner-container-left {
        width: 47%;
        float: left;
        margin-left: 10px;
    }

    .inner-container-right {
        width: 47%;
        float: right;
        margin-right: 10px;
    }

    .spacer {
        width: 6%;
    }

    @media only screen and (max-width: 600px) {
        .spacer {
            width: 5%;
        }

        .input-group-image {
            width: 90%;
        }

        .image-spacer {
            width: 5%;
        }
    }

</style>
